import React from 'react';
import { Input, InputProps } from '../Input/Input';

export interface SchoolDomainInputProps extends InputProps {
  showSchoolDomain?: boolean;
  schoolDomain?: string;
  icon?: React.ReactNode;
}

function SchoolDomainInput({ showSchoolDomain, schoolDomain, icon, ...rest }: SchoolDomainInputProps) {
  return (
    <div className="pos-rel schoolDomainInput">
      <Input {...rest} />
      {showSchoolDomain && (
        <div className="schoolDomain">
          @
          {schoolDomain}
        </div>
      )}
    </div>
  );
}

export default SchoolDomainInput;
